import React from 'react'
import { Row, Col } from 'react-bootstrap'

import './style.scss'

const Index = ({handleSearch}) => {
	return(
		<Row className="client-sales-history-row">
			<Col className="search-field-col my-auto text-left">
				<div className="search-container">
						<button className="search-button"><i className="fas fa-search"></i></button>
						<input onChange={(e) => handleSearch(e)} type="text" placeholder="Søk.."/>
				</div>
			</Col>
		</Row>
	)
}

export default Index